// Pure floor logic for FyMultiSelect's onChange wrapper (FE-13, A-121) — kept standalone so it
// is unit-testable without mounting the dropdown. The selection can only be emptied by deselecting
// through the Select All row or by unchecking the last remaining year; both funnel through the
// same onChange, so intercepting here covers both.

/** An empty result is replaced by the latest year of the pre-change selection — the floor
 *  blocks only the LAST removal, never a normal one. */
export function applyFyFloor(next: string[], previouslySelected: string[]): string[] {
    if (next.length) return next;
    const latest = Math.max(...previouslySelected.map(Number));
    return [String(latest)];
}

export function sameFySet(a: string[], b: string[]): boolean {
    if (a.length !== b.length) return false;
    const sortedA = [...a].sort();
    const sortedB = [...b].sort();
    return sortedA.every((value, index) => value === sortedB[index]);
}
